import { useState } from "react";
import { Configuration, OpenAIApi } from "openai";
// import Input from '@mui/material/Input';
import {BsFillArrowRightSquareFill as Icon} from "react-icons/bs" 

function App() {
  const configuration = new Configuration({
    apiKey:process.env.REACT_APP_OPENAI_API_KEY,
  });
  const openai = new OpenAIApi(configuration);
  // console.log(process.env.REACT_APP_OPENAI_API_KEY);

  const [ prompt, setPrompt ] = useState("");
  const [ result, setResult ] = useState("");
  const [ loading, setLoading ] = useState(false);



  const handleClick = async () => {
    setLoading(true);
    try {
      const response = await openai.createCompletion({
        model: "text-davinci-003",
        prompt: prompt + "according to the verses in Bhagwad Gita ",
        temperature: 0.7, //TESTING WITH 0.7  change to 0.5 when needed
        max_tokens: 100,
      });
      setResult(response.data.choices[0].text);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (

    <main className="main">
      <div className="w-2/4 mx-auto">

      <div className = "banner">

      Ask the <b><i>Bhagwad Gita</i></b> 
      {/* <br></br> */}
      to guide you 🦚

      </div>
        <div className="wrapper">
          <Icon 
          className="icon"
          onClick={ handleClick }></Icon>
          <textarea
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="eg. What should one do when they feel betrayed?"
            className="textarea"
          ></textarea>
        </div>
        
        {/* <button
          onClick={handleClick}
          disabled={loading || prompt.length === 0}
          className="btn"
        >
          {loading ? "..." : "Ask Away"}
        </button> */}
        
        {/* <div className="result">{result}</div> */}
        <div className="result-box">
          <div className="result">{result}</div>
        </div>
        
      </div>

      <div className="footer">

        Built with 💖 by 
        <a className = "text" href="https://akash-wtf.vercel.app/" target="_blank" title="The Developer" ><u>
          @Akash 
          </u>{` `}
        </a> 
        
         and {` `}
        <a className = "text" href="https://en.wikipedia.org/wiki/Krishna" target="_blank" title="He answers your questions"><u>Krishna</u></a>
        
      </div>
    </main>
  );
}

export default App;
